export default __webpack_public_path__ + "static/media/plushighlight.cf4b8628.svg";